// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__XKFgp","title":"Info_title__24c32","links":"Info_links__3rA35","link":"Info_link__1aJV4","logo":"Info_logo__3GQ33"};